module.exports = __webpack_public_path__ + "static/media/rounded-rect-blue.a7478ede.png";